export const BRAND_CONFIG = {
	ADISTA: {
		title: "Adista",
		icon: "/logo_adista.svg",
	},
	TERRENOVA: {
		title: "Terrenova",
		icon: "/logo_terrenova.svg",
	},
	OPTIVIEW: {
		title: "Optiview",
		icon: "/logo_iec_telecom_Favicon.svg",
	},
};
